import { render, staticRenderFns } from "./floorImg-two.vue?vue&type=template&id=4abf5f24"
import script from "./floorImg-two.vue?vue&type=script&lang=js"
export * from "./floorImg-two.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports